module.exports = __webpack_public_path__ + "static/media/alertDefault.d8168d87.svg";